<template>
    <div class="flyout-guide-mark">
        <div class="flyout-guide-mark-ring" />
        <div class="flyout-guide-mark-circle" />
    </div>
</template>

<script>
export default {
    name: 'FlyoutGuideMark',
};
</script>

<style scoped lang="scss">
.flyout-guide-mark {
    position: relative;
    z-index: -1;

    &-circle {
        width: 12px;
        height: 12px;
        position: absolute;
        border-radius: 50%;
        background-color: $eastern;
    }

    &-ring {
        height: 24px;
        width: 24px;
        position: absolute;
        border: 2px solid $eastern;
        border-radius: 30px;
        opacity: 0;
        animation: pulsate 1s ease-out;
        animation-iteration-count: infinite;
        box-sizing: content-box; // Override AUI shim styling
    }

    @keyframes pulsate {
        0% {
            transform: translate(-8px, -8px) scale(0.1, 0.1);
            opacity: 0;
        }

        50% {
            opacity: 1;
        }

        100% {
            transform: translate(-8px, -8px) scale(1, 1);
            opacity: 0;
        }
    }
}
</style>
